// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/actionTypes');
const { REPAGINATION_ALL } = require('constants/index');

const reset = () => ({
    type: actionTypes.OPEN_YOUNG_RESET_BENEFICIARY_DOCUMENTATION_DATA
});

const getCardBeneficiaryInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_GET_CARD_BENEFICIARY_REQUEST
});

const getCardDocumentationDataInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_GET_CARD_DOCUMENTATION_DATA_REQUEST
});

const getCardBeneficiaryDocumentationFailure = errorDescription => ({
    type: actionTypes.OPEN_YOUNG_GET_BENEFICIARY_DOCUMENTATION_DATA_FAILURE,
    payload: {
        errorDescription
    }
});

const getCardBeneficiarySuccess = response => ({
    type: actionTypes.OPEN_YOUNG_GET_CARD_BENEFICIARY_SUCCESS,
    payload: {
        response
    }
});

const getCardBeneficiaryData = immCard => dispatch => {
    const requestData = {
        query: {
            codEstRef: immCard.getIn(['product', 'standard']),
            codigoSubtipo: immCard.getIn(['product', 'subtype']),
            numeroContrato: immCard.getIn(['contract', 'number']),
            numeroTarjeta: immCard.get('number'),
            producto: immCard.getIn(['contract', 'product']),
            repaginacion: REPAGINATION_ALL,
        }
    }

    return APIPost(dispatch, apiURLBuilder.getURL('openYoungGetCardBeneficiary'), requestData);
};

const getCardBeneficiary = immCard => dispatch => {
    dispatch(getCardBeneficiaryInProgress());
    return dispatch(getCardBeneficiaryData(immCard))
        .then(response => dispatch(getCardBeneficiarySuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(getCardBeneficiaryDocumentationFailure(response.error));
            } else {
                throw response;
            }
        }
    );
};

const getCardDocumentationData = (beneficiaryData, accountIban) => dispatch => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            numeroExpediente: accountIban,
            persona: {
                codigodepersona: beneficiaryData.numeroPersonaCliente.codigodepersona,
                tipodepersona: beneficiaryData.numeroPersonaCliente.tipodepersona,
            },
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('openYoungGetCaseFile'), requestData);
};

const getCardDocumentationDataSuccess = response => ({
    type: actionTypes.OPEN_YOUNG_GET_CARD_DOCUMENTATION_DATA_SUCCESS,
    payload: {
        response
    }
});
const getCardDocumentationDataReset = () => ({
    type: actionTypes.OPEN_YOUNG_GET_CARD_DOCUMENTATION_DATA_RESET
});


const getCardDocumentationState = cardId => (dispatch, getState) => {
    if (!getState().openYoungDocumentation.get('isFetching')) {
        dispatch(getCardDocumentationDataInProgress());

        const immCard = getState().cards.getIn(['byId', cardId]);
    
        return dispatch(getCardBeneficiaryData(immCard))
            .then(response => dispatch(getCardDocumentationData(response, immCard.get('number').replace(/\s/g,'')))
                .then(response => dispatch(getCardDocumentationDataSuccess(response)))
                .catch(response => {
                    if (!!response.error) {
                        dispatch(getCardBeneficiaryDocumentationFailure(response.error));
                    } else {
                        throw response;
                    }
            })
        );   
    }
};

module.exports = {
    getCardBeneficiary,
    getCardDocumentationState,
    getCardDocumentationDataReset,
    reset,
};
